<template>
  <v-container fluid grid-list-xs v-if="paymentToken">
    <v-card>
      <v-card-text>
        <v-layout align-center row wrap>
          <v-flex xs2 class="primary--text pa-1 font-weight-black">
            <img
              :src="'/static/cards/' + paymentToken.payment_type + '.svg'"
              height="24px"
              v-if="paymentToken.payment_type && paymentToken.payment_type!=='unknown' && paymentToken.payment_type!=='ach'"
            />
            <v-chip v-if="paymentToken.payment_type==='ach'" color="primary lighten-4 ma-0">ACH</v-chip>
          </v-flex>
              <v-flex class="overflow-hidden">
                <span class="font-weight-black">{{ paymentToken.token }}</span>
              </v-flex>
          <v-flex xs10 class="pa-1">
            <v-layout align-center reverse row wrap>
              <v-flex class="text-xs-right" v-if="showActions && !isExpired">
                <v-btn color="error" @click="setStatus(0)" round small v-if="paymentToken.is_active">Disable</v-btn>
                <v-btn color="success" @click="setStatus(1)" round small v-if="!paymentToken.is_active">Enable</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs6 md2 class="primary--text pa-1 font-weight-black text-no-wrap">Last Four:</v-flex>
          <v-flex xs6 md4 class="pa-1">{{ paymentToken.last_four }}</v-flex>

          <v-flex xs6 md2 class="primary--text pa-1 font-weight-black"><span v-if="paymentToken.payment_type!=='ach'">Expiration:</span></v-flex>
          <v-flex xs6 md4 class="pa-1"><span :class="isExpired ? 'white--text error' : ''" v-if="paymentToken.payment_type!=='ach'">{{ expiration(paymentToken.card_expiration_yymm) }}</span></v-flex>

          <v-flex xs6 lg2 class="primary--text pa-1 font-weight-black">Created:</v-flex>
          <v-flex xs6 lg4 class="pa-1">{{ datetime(paymentToken.created) }}</v-flex>

          <v-flex xs6 lg2 class="primary--text pa-1 font-weight-black">Last Used:</v-flex>
          <v-flex xs6 lg4 class="pa-1">{{ datetime(paymentToken.last_used) }}</v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-layout row wrap v-if="showActions" class="text-xs-right">
          <v-flex class="pb-2">
            <v-btn color="primary" :disabled="!!paymentToken.is_active" :to="{ name: 'VirtualTerminal', query: { token_id: paymentToken.id, billing_id: billing.id }}" v-if="!isExpired">Charge Customer</v-btn>
          </v-flex>
          <v-flex class="pb-2">
            <v-btn color="primary" :disabled="true">Update Token</v-btn>
          </v-flex>
          <v-flex class="pb-2">
            <v-btn color="primary" :disabled="true">Tokenize on Different Account</v-btn>
          </v-flex>
          <v-flex class="pb-2" v-if="hasPermission('superuser')">
            <v-btn color="primary darken-2" :disabled="!!!paymentToken.is_active || isExpired" :to="{ name: paymentToken.payment_type==='ach' ? 'StandaloneRefundACH' : 'StandaloneRefund', query: { token_id: paymentToken.id, billing_id: billing.id }}" v-if="!isExpired">Standalone Refund</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin],

  props: {
    paymentToken: Object,
    billing: Object,
    showActions: Boolean
  },

  computed: {
    isExpired () {
      if (this.paymentToken.card_expiration_yymm) {
        let month = this.paymentToken.card_expiration_yymm.slice(-2)
        let year = this.paymentToken.card_expiration_yymm.slice(0, 2)
        let currentDate = new Date()

        if (currentDate.getFullYear() > 2000 + Number(year)) {
          return true
        } else if (currentDate.getFullYear() === 2000 + Number(year) && currentDate.getMonth() + 1 >= Number(month)) {
          return true
        }
      }

      return false
    }
  },

  methods: {
    async setStatus (isEnabled = 1) {
      let subPath = 'enable'
      if (isEnabled === 0) {
        subPath = 'disable'
      }

      if (confirm(`Are you sure you would like to ${subPath} this token?`)) {
        try {
          Bus.$emit('openWaitModal')

          await this.api({
            method: 'put',
            url: `/tokens/${this.paymentToken.id}/${subPath}`
          })

          // reload user or switch value?
          let data = await this.api({url: `/tokens/${this.$route.params.id}`})
          this.user = data.data.user
        } catch (error) {
          console.log('Error updating status')
          console.log(error)
        } finally {
          Bus.$emit('closeWaitModal')
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/terminal/components/PaymentTokenCard.vue